import { css, styled } from 'canoe';
import React from 'react';

export const Container = styled.div`
  ${({ theme }) => css`
    padding: ${theme.spaces.l};
    background-color: ${theme.colors.White};

    > div {
      display: grid;
      grid-gap: ${theme.spaces.s};
    }
  `}
`;
type AnalyticsCardProps = {
  children: React.ReactNode;
};

export const AnalyticsCard = React.memo(({ children }: AnalyticsCardProps) => (
  <Container>
    <div>{children}</div>
  </Container>
));
